import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function validateTokenConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'login/validate_token',
    method: NetworkRequestConfiguration.Methods.GET,
  });
}
